





import { Component, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'
import auth from '@/services/authService'
import { User } from '@/services/data'
@Component
export default class App extends Vue {
  getJwt () {
    return sessionStorage.getItem('jwt') || localStorage.getItem('jwt')
  }

  @Watch('$route')
  private async onRouteChange (route: Route) {
    const jwt = this.getJwt()
    if (jwt) {
      const res = await auth.checkLoginAsync(jwt)
      if (res.Result === true) {
        const userString = decodeURIComponent(escape(window.atob(jwt.split('.')[1])))
        const user = JSON.parse(userString)
        const userData: User = {
          email: user.LoginId,
          name: user.Name,
          accNo: user.AccNo,
          jwt: jwt
        }
        this.$store.commit('setUser', userData)
        const name = route.name
        const checkLogin = (name === 'index' || name === 'login')
        if (checkLogin) {
          await this.$router.push('/home/dashboard')
        }
      } else { // failure login
        if (name !== 'login') {
          sessionStorage.removeItem('jwt')
          localStorage.removeItem('jwt')
          await this.$router.push('/login')
        }
      }
    } else {
      if (name !== 'login') {
        await this.$router.push('/login')
      }
    }
  }
}
